import AboutTemplate from "../../components/about/AboutTemplate";
import Page from "../Page";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import DeveloperNotes from "../../components/about/DeveloperNotes";
import Section from "../../components/about/Section";
import Button from "../../components/input/button";
import React from "react";

const WhatIsMindstack = () => {
  return (
    <Page
      className="about-page what-is-mindstack-page"
      pageKey="what-is-mindstack"
    >
      <AboutTemplate>
        <div className="about-page_section">
          <Typography variant="h1">What is Mindstack?</Typography>
          <Typography variant="p1">
            Mindstack is a productivity app designed for people who struggle to
            stay productive.
          </Typography>
          <Typography variant="p1">
            For the people who are tired of endless sticky notes and scattered
            to-do lists. For the people who are wondering where to start.
          </Typography>
        </div>

        <div className="about-page_section">
          <Typography variant="h2">What does it do?</Typography>
          <Typography variant="p1">
            Mindstack provides a place to keep all of your tasks in once place
            and a way to stay focused on the tasks that matter most.
          </Typography>
          <Typography variant="p1">
            Tasks are kept in a "stack" and automatically ordered based on their
            importance and urgency. It is very easy to see, at a glance, which
            tasks you should probably prioritize
          </Typography>
          <Typography variant="p1">
            You can add deadlines, labels and notes to your tasks to help you
            stay organized, and tasks can be targeted to help you stay focused
            on your near-term goals.
          </Typography>
          <Typography variant="p1">
            Read more about{" "}
            <Link component={RouterLink} to="/about/features" variant="p1">
              Mindstack's features
            </Link>
          </Typography>
        </div>

        <Section>
          <Button text="Start using Mindstack" color="orange" link="/tasks" />
        </Section>

        <DeveloperNotes>
          <Typography variant="p1">
            I'm Sam, a web developer from Manchester, and I made Mindstack for
            myself.
          </Typography>
          <Typography variant="p1">
            I've always struggled to keep track of the things I need to do. I've
            tried sticky-notes and paper lists, but they never really worked for
            me. Lists get misplaced or forgotten about, and the sight of
            sticky-notes stuck everywhere can be a little overwhelming.
          </Typography>
          <Typography variant="p1">
            Digital calendars & note lists I find more useful, but they still
            lacked a sort of "bigger picture" view of everything I needed to do.
            Tasks slide down the list and I sometimes lose sight of important
            things, buried under more menial tasks.
          </Typography>
          <Typography variant="p1">
            I made Mindstack to keep everything in one place, and prioritise
            things so I can tell at a glance what I need to do, and it has grown
            from there.
          </Typography>
          <Typography variant="p1">
            Not everyone will find Mindstack useful, but personally I've found
            it has helped quite a lot, and perhaps it can help you get more
            focused too.
          </Typography>
        </DeveloperNotes>
      </AboutTemplate>
    </Page>
  );
};

export default WhatIsMindstack;
